import { AppState } from 'Store'
import { createSelector } from 'reselect'
import { NAME_CONTRACT, TYPE_PARTNER_DOCUMENT } from 'Pages/partner'

const contracts = (state: AppState) =>
	state?.partner?.partners?.documents?.[TYPE_PARTNER_DOCUMENT.CONTRACT_DOCUMENTS] ?? {}
const tags = (state: AppState) => state.partner.contracts.tags.entries
const partnerId = (state: AppState) => state?.page?.entity?.id

const linkedContracts = createSelector(contracts, (contract_documents) =>
	[
		...(contract_documents[NAME_CONTRACT.CONTRACTS]?.documents ?? []),
		...(contract_documents[NAME_CONTRACT.PROCESSED_OFFER_LETTERS]?.documents ?? []),
	].reduce((items, document) => {
		if (document.human_file_name) {
			items.push({
				id: document.human_file_name,
				name: document?.human_file_name,
			})
		}
		return items
	}, [])
)

export const contractsSelectors = {
	contracts,
	linkedContracts,
	tags,
	partnerId,
}
